import {
  createLogger
} from "./chunk-R2PM4C72.js";

// src/date.ts
var logger = createLogger({ prefix: "DateUtils" });
function toDate(date) {
  return typeof date === "string" ? new Date(date) : date;
}
function isValidDate(date) {
  return !Number.isNaN(date.getTime());
}
var LOCALE_MAP = {
  "pt-br": "pt-BR",
  en: "en-US",
  es: "es"
};
function resolveLocale(locale) {
  if (!locale) {
    return "pt-BR";
  }
  return LOCALE_MAP[locale] ?? locale;
}
var formatDateForInput = (date) => {
  if (date == null) {
    return "";
  }
  try {
    const dateObj = new Date(date);
    if (!isValidDate(dateObj)) {
      return "";
    }
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch (error) {
    logger.error("Error formatting date for input", { date, error });
    return "";
  }
};
var formatDateToLocale = (date) => {
  if (date == null) {
    return "";
  }
  try {
    const dateObj = new Date(date);
    if (!isValidDate(dateObj)) {
      return "";
    }
    return dateObj.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch (error) {
    logger.error("Error formatting date to locale", { date, error });
    return "";
  }
};
function formatDate(date, style = "long", locale) {
  try {
    const dateObj = toDate(date);
    if (!isValidDate(dateObj)) {
      return "";
    }
    if (style === "iso") {
      return formatDateForInput(dateObj.toISOString());
    }
    const resolvedLocale = resolveLocale(locale);
    const optionsMap = {
      long: { dateStyle: "long" },
      "long-time": { dateStyle: "long", timeStyle: "short" },
      short: { year: "numeric", month: "short", day: "2-digit" },
      "short-time": {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      }
    };
    return new Intl.DateTimeFormat(resolvedLocale, optionsMap[style]).format(
      dateObj
    );
  } catch (error) {
    logger.error("Error formatting date", { date, style, error });
    return "";
  }
}
function formatRelativeTime(date, locale) {
  try {
    const dateObj = toDate(date);
    if (!isValidDate(dateObj)) {
      return "";
    }
    const now = /* @__PURE__ */ new Date();
    const diffMs = dateObj.getTime() - now.getTime();
    const absDiffSeconds = Math.abs(Math.round(diffMs / 1e3));
    const resolvedLocale = resolveLocale(locale);
    const rtf = new Intl.RelativeTimeFormat(resolvedLocale, { numeric: "auto" });
    if (absDiffSeconds < 60) {
      return rtf.format(Math.round(diffMs / 1e3), "second");
    }
    if (absDiffSeconds < 3600) {
      return rtf.format(Math.round(diffMs / 6e4), "minute");
    }
    if (absDiffSeconds < 86400) {
      return rtf.format(Math.round(diffMs / 36e5), "hour");
    }
    if (absDiffSeconds < 2592e3) {
      return rtf.format(Math.round(diffMs / 864e5), "day");
    }
    if (absDiffSeconds < 31536e3) {
      return rtf.format(Math.round(diffMs / 2592e6), "month");
    }
    return rtf.format(Math.round(diffMs / 31536e6), "year");
  } catch (error) {
    logger.error("Error formatting relative time", { date, error });
    return "";
  }
}

export {
  formatDateForInput,
  formatDateToLocale,
  formatDate,
  formatRelativeTime
};
//# sourceMappingURL=chunk-JH7IR64L.js.map